export enum ProfileStatus {
  active = 'ACTIVE',
  inactive = 'INACTIVE',
}
